import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import VueCookies from 'vue-cookies'

import { VueAxios } from './axios'
// import { Object } from 'core-js'
const ACCESS_TOKEN = 'aaa'
// 创建 axios 实例
const service = axios.create({
  baseURL: '/api', // api base_url
  timeout: 60000 // 请求超时时间
})

const err = error => {
  if (error.response) {
    const data = error.response.data
    // const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      // notification.error({
      //   message: 'Forbidden',
      //   description: data.message
      // })
    }
    if (
      error.response.status === 401 &&
      !(data.result && data.result.isLogin)
    ) {
      // notification.error({
      //   message: 'Unauthorized',
      //   description: 'Authorization verification failed'
      // })
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => { 
  let token = VueCookies.get('token')
//  token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJvY3BfMTV4a19XQTFYVVhWQUk2S1VTVk96N3MwIiwianRpIjoiYzBiNDhmMzItNjg5NS00MmIzLWJhOGUtOTY3NWY4YWRkODlmIiwiZXhwIjoxNjI3MTQxMTYzLCJpc3MiOiJodHRwczovL3d3dy5jbmJsb2dzLmNvbS9jaGVuZ3RpYW4iLCJhdWQiOiJodHRwczovL3d3dy5jbmJsb2dzLmNvbS9jaGVuZ3RpYW4ifQ.se1_z67aObC6Bob3XFOLNlBt0Dvx6begXPs4TYi3wns'
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use(response => {
  if (response.data.code) {
    if (response.data.code === '3004') {
      // TODO 3004
      localStorage.clear()
      window.location.href = '/#/user/login'
      throw new axios.Cancel(
        'Operation canceled by the user.' + JSON.stringify(response.data)
      )
    } 
    // else if (response.data.code !== '0000') {
    //   // notification.error({
    //   //   message: '错误',
    //   //   description: response.data.msg || '请求出现错误，请稍后再试',
    //   //   duration: 4
    //   // })
    //   throw new axios.Cancel(
    //     'Operation canceled by the user.' + JSON.stringify(response.data)
    //   )
    // }
  }
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export { installer as VueAxios, service as axios }
